<template>
  <div class="box4">
    <pageTitle
      title="学好C/C++&nbsp;&nbsp;才是企业“稀缺级”人才"
      text="如果通向大牛的道路有捷径，那就是先学好C语言！"
    />

    <div class="title-box">
      <div class="icon">更有优势</div>
      <div class="title">· 游戏服务器开发经验</div>
      <div class="title">· 双系统文件传输经验</div>
      <img src="../../../assets/coursePage/cPuls/box4/icon.png" alt="" />
    </div>

    <div class="content-box">
      <p>C/C++工程师核心技能</p>
      <div class="content">
        <div class="left">
          <div>Shell脚本编程</div>
          <div>网络攻防</div>
          <div>zinx框架</div>
          <div>数据库</div>
          <div>网络编程</div>
          <div>负载均衡</div>
        </div>
        <div class="right">
          <div>C/C++核心编程</div>
          <div>Qt开发</div>
          <div>容器化</div>
          <div>微服务</div>
          <div>分布式并发</div>
          <div>Linux系统编程</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.box4 {
  padding: 80px 0px 88px;
  width: 100%;
  background: #dbf4ff;
  background: url("../../../assets/coursePage/cPuls/box4/bgc.png") no-repeat;
  background-size: cover;
  .title-box {
    width: 686px;
    height: 228px;
    background: linear-gradient(180deg, #ceedff 0%, #ffffff 100%);
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    border: 2px solid #ffffff;
    position: relative;
    padding-top: 90px;
    padding-left: 56px;
    box-sizing: border-box;
    margin: 48px auto 0;

    .icon {
      background: url("../../../assets/coursePage/cPuls/box4/leftTop.png")
        no-repeat;
      width: 184px;
      height: 52px;
      position: absolute;
      top: 0;
      left: 0;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 52px;
      text-align: center;
      background-size: cover;
    }
    img {
      right: 0;
      bottom: 0;
      position: absolute;
      width: 294px;
      height: 192px;
    }
    .title {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1d2129;
      line-height: 44px;
      margin-bottom: 8px;
    }
  }
  .content-box {
    width: 686px;
    padding-bottom: 8px;
    background: #ffffff;
    box-shadow: 0px 8px 20px 0px #e2edf5;
    border-radius: 20px;
    border: 2px solid #ffffff;
    margin: 32px auto 0;
    padding: 32px 32px 8px 32px;
    box-sizing: border-box;
    p {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #4e5969;
      line-height: 44px;
      background: linear-gradient(270deg, #0080ff 0%, #76b9ff 100%);
      display: flex;
      align-items: center;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-align: center;
      justify-content: center;

      &::before {
        background: url("../../../assets/coursePage/cPuls/box4/textIcon.png")
          no-repeat;
        content: "";
        display: block;
        width: 40px;
        height: 40px;
        background-position: center;
        background-size: cover;
        margin-right: 16px;
      }
      &::after {
        background: url("../../../assets/coursePage/cPuls/box4/textIcon.png")
          no-repeat;
        content: "";
        display: block;
        width: 40px;
        height: 40px;
        background-position: center;
        background-size: cover;
        margin-left: 16px;
      }
    }
    .content {
      display: flex;
      justify-content: space-between;
      margin-top: 32px;
    }
    .left,
    .right {
      div {
        width: 298px;
        height: 76px;
        background: url("../../../assets/coursePage/cPuls/box4/item.png")
          no-repeat;
        border-radius: 16px;

        margin-bottom: 24px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 76px;
        text-align: center;
        box-sizing: border-box;
        background-size: cover;
      }
    }
    .right {
    }
  }

  .tip {
    margin-top: -5px;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 26px;
    letter-spacing: 0px;
    color: #0080ff;
  }
}
</style>
